import React, { useMemo } from 'react';
import { vendorAccountType } from '@Reducers/AdminShipment/Type';
import { Grid, Paper, Typography } from '@mui/material';
import SBDropdown from '@Components/Dropdown';
import { useFormik } from 'formik';
import { AppDispatch, RootStateType } from '@Store';
import { useDispatch, useSelector } from 'react-redux';
import { addCarrierSettings, updateCarrierSettings } from '@Reducers/User/actions';
import SbButton from '@Components/Button';
import Divider from '@Components/Divider';
import * as Yup from 'yup';
import { delhiveryCarrier } from './Type';
import { setCarrierSettings } from '@Reducers/User';
import {
  PaymentModeOptions,
  PickupLocationTypeOptions,
  ShippingModeOptions,
} from '../../ViewSingleShipmentAdmin/components/ShipmentProcessingV2/components/Delhivery/constants';

interface propsTypes {
  onClose: () => void;
  isEditable: boolean;
}

// ... validation schema from above ...
const delhiveryValidationSchema = Yup.object().shape({
  accountNo: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Account value is required'),
        display: Yup.string().required('Account display is required'),
      }),
    )
    .min(1, 'At least one account number is required')
    .required('Account number is required')
    .default([]),

  pickup_location: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Pickup location value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Pickup location is required')
    .required('Pickup location is required')
    .default([]),

  payment_mode: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Payment mode value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Payment mode is required')
    .required('Payment mode is required')
    .default([]),
  shipping_mode: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Shipping mode value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Shipping mode is required')
    .required('Shipping mode is required')
    .default([]),
});

const Delhivery = (props: propsTypes) => {
  const { onClose, isEditable } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { vendersAccount } = useSelector((state: RootStateType) => state.adminShipment);
  const { userDataById, carrierSetting } = useSelector((state: RootStateType) => state.user);

  const accountOptions = useMemo(
    () =>
      vendersAccount?.map((item: vendorAccountType) => ({
        value: `${item.accountNo}-${item._id}`,
        display: item.name,
      })),
    [vendersAccount],
  );

  const { values, setFieldValue, errors, handleSubmit } = useFormik<delhiveryCarrier>({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: delhiveryValidationSchema,
    initialValues: {
      ...carrierSetting.delhivery,
      // type: 'D-D',
    },
    onSubmit(values) {
      if (userDataById?._id) {
        if (carrierSetting.delhivery._id) {
          dispatch(updateCarrierSettings({ ...carrierSetting.delhivery, ...values }));
        } else {
          dispatch(addCarrierSettings({ ...carrierSetting.delhivery, ...values }));
        }
      } else {
        dispatch(setCarrierSettings({ values, carrierType: 'delhivery' }));
      }
      onClose();
    },
  });

  return (
    <div>
      <>
        <Paper
          variant="outlined"
          sx={{
            my: '2rem',
            p: '2rem',
          }}
        >
          <Grid container item xs={12}>
            <Grid container item mb={3}>
              <Grid item xs={12} md={6}>
                <Typography className="font-medium l-text pb-3">Delhivery Information</Typography>{' '}
              </Grid>
            </Grid>
            <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="accountNo"
                    label={`Delhivery Account`}
                    required
                    multiple={true}
                    placeholder="Select"
                    name="accountNo"
                    value={values?.accountNo?.map(item => item.value)}
                    options={accountOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('accountNo', selectedObj);
                    }}
                    error={Array.isArray(errors.accountNo) ? errors.accountNo.join(', ') : errors.accountNo}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="pickup_location"
                    label={`Pickup location`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="pickup_location"
                    value={values?.pickup_location?.map(item => item.value)}
                    options={PickupLocationTypeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('pickup_location', selectedObj);
                    }}
                    error={errors.pickup_location as string}
                  />
                </Grid>
              </Grid>

              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="payment_mode"
                    label={`Payment mode`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="payment_mode"
                    value={values?.payment_mode?.map(item => item.value)}
                    options={PaymentModeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('payment_mode', selectedObj);
                    }}
                    error={errors.payment_mode as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="shipping_mode"
                    label={`Shipping mode`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="shipping_mode"
                    value={values?.shipping_mode?.map(item => item.value)}
                    options={ShippingModeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('shipping_mode', selectedObj);
                    }}
                    error={errors.shipping_mode as string}
                  />
                </Grid>
              </Grid>

              <Divider className="mt-3 mb-3" />
              <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
                <Grid container item sx={{ gap: '1rem' }}>
                  <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                    <SbButton
                      type="submit"
                      disabled={!isEditable}
                      variant="contained"
                      sx={{ borderRadius: `4px !important` }}
                      className="w-full"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Save
                    </SbButton>
                  </Grid>
                  {onClose && (
                    <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                      <SbButton
                        type="button"
                        sx={{ borderRadius: `4px !important` }}
                        className="w-full"
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </SbButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    </div>
  );
};

export default Delhivery;
